import choice from "./Choice";
import textType from "./TextType";
import rating from "./Rating";
import likert from "./Likert";

export default {
    choice,
    textType,
    rating,
    likert
}